<template>
	<div class="dashboard">
		<top-header></top-header>
		<b-container>
		<b-container fluid class="mb-2 mt-2 d-block d-sm-block d-md-none">
			<auto-complete></auto-complete>
			<!--<form @submit.prevent="changeQuerysearch">
                 
				  <b-input-group class="mt-3" style="min-width:280px;border:0px; border-radius:25px !important">
					<b-form-input placeholder="Search for products, brands etc."  :class="{ loading : loading === true }" v-model="query" style="border-radius: 25px 0px 0px 25px !important;" ></b-form-input>
					<b-input-group-append>
					  
					  <b-button type="submit" variant="warning" style="border-radius: 0 25px 25px 0px;color: #fff;" ><i class="fa fa-search" aria-hidden="true"></i></b-button>
					</b-input-group-append>
				  </b-input-group>
				  
            </form> -->
        </b-container >
        <b-container fluid class="mb-3 " style="margin-top:1%;">
            <b-row>
                <b-col class="px-0">
                    <b-carousel id="carousel-1" v-model="slide" :interval="4000" controls indicators  background="#dddddd" img-width="1200"  img-height="500" style="text-shadow: 1px 1px 2px #333; "
      :no-hover-pause=true class="homecarousel">
						 
						
	  
                        <b-link href="/women"> <b-carousel-slide :img-src="$root.MEDIAPATH+'banners/Alluraa-Main-Slider-Banner-01.jpg'" class="homescrollImgHeight" ></b-carousel-slide></b-link>
                        <b-link href="/register/seller"><b-carousel-slide :img-src="$root.MEDIAPATH+'banners/Alluraa-Main-Slider-Banner-02.jpg'" class="homescrollImgHeight" ></b-carousel-slide></b-link>
						 <b-link href="/cosmetics"> <b-carousel-slide :img-src="$root.MEDIAPATH+'banners/Alluraa-Main-Slider-Banner-03.jpg'" class="homescrollImgHeight" ></b-carousel-slide></b-link>
                        <!--<b-carousel-slide :img-src="$root.MEDIAPATH+'banners/17a0e514-2928-418d-9050-f6e661a1ccab.jpg'"></b-carousel-slide>
						<b-carousel-slide :img-src="$root.MEDIAPATH+'banners/45c0461d-fb33-4a9f-b9fb-107d36c85153.jpg'"></b-carousel-slide> -->
                    </b-carousel>
                </b-col>
            </b-row>
        </b-container>
			<!-- <Banner></Banner>  -->
				<b-container class="pt-4 px-0 joinas">
					<b-row class="justify-content-center">
						<!-- Brand Partnership Card -->
						<b-col cols="12" md="6" lg="6" >
						<b-card class="text-center p-4 shadow-sm card-fixed-height">
							<div class="avatar-wrapper mb-4 mx-auto">
							<b-img
								src="https://www.alluraa.com/media/banners/category/Saree.png"
								rounded="circle"
								width="100"
								height="100"
								alt="Brand"
								class="imgjoinas"

							/>
							<span class="tag-badge">⭐</span>
							<span class="tag-label">+35%</span>
							</div>

							<h4 class="mb-3 text-dark font-weight-bold">Brand Partnerships</h4>

							<p class="text-muted px-3 text-left">
								Our platform connects brands and retailers with thousands of Influencers all over the world, using different social media platforms. We help sellers list their Brands and open online store in less than 5 minutes.
							</p>

							<b-button size="lg" rounded="top" class="mt-4 cart-btn-become" href="/register/seller">JOIN AS BRAND</b-button>
						</b-card>
						</b-col>

						<!-- Influencer Marketing Card -->
						<b-col cols="12" md="6" lg="6" >
						 <b-card class="text-center p-4 shadow-sm card-fixed-height d-flex flex-column justify-content-between" > 
							<div class="avatar-wrapper mb-4 mx-auto">
								<b-img
									src="/img/Alluraa-Influencer-Tile-041.0db2203c.png"
									rounded="circle"
									width="100"
									height="100"
									alt="Publisher"
									class="imgjoinas"
								/>
								<span class="tag-badge">📊</span>
								<span class="tag-label">Online</span>
								</div>
							<h4 class="mb-3 text-dark font-weight-bold">Influencer Marketing</h4>
							<p class="text-muted px-3 text-left">
								Influencers and content creators partner with Sellers and Brands to increase reach by leveraging their established audience, creating engaging content, and strategically using social media platforms to reach new demographics.
							</p>

							<b-button size="lg" rounded="top" class=" mt-4 cart-btn-become" href="/marketing/influencer">JOIN AS INFLUENCER</b-button>

						</b-card>
						</b-col>
					</b-row>
					</b-container>
				
			
		
		
			


			<CircleSlider></CircleSlider>
			 <!--<Deals></Deals> -->
			<h3 class="pt-4 mb-0"><b-link href="trending-products" style="color:#2c3e50;"># TRENDING PRODUCTS</b-link></h3>
			 <Deals :products="related_products" :showQuickViewListener="$root.showQuickView" heading="Related Products"></Deals>
			<!--<Offers></Offers>-->
			  <h3 class="pt-4">OFFERS</h3>
			 <Offers-by-category></Offers-by-category>
			  <h3 class="pt-4">EXPLORE TOP BRANDS</h3>
			 <TopBrands></TopBrands>
			 
			 <!-- <h3 class="pt-4 pb-1"><b-link href="/marketing/influencer" style="color:#2c3e50;">BECOME AN INFLUENCER</b-link></h3>
			 <b-container  class="mb-3">
			  <b-row>
				<b-col class="px-0">
				<b-link href="/marketing/influencer">
				 		
				<b-img v-bind="mainProps"  src="https://www.alluraa.com/media/images/banner-sales-advisor-home01.png" fluid style="border-radius:10px;"></b-img>
				  </b-link>
				</b-col>
			  </b-row>
			</b-container> -->
				
				


				
	
			
			

			 <Clients></Clients>
			 
		
		
			
			
			
		
		
		</b-container>
		<top-footer></top-footer>
	
			<footer-seo></footer-seo>
		<!--<diwali-popup></diwali-popup> -->
		
	</div>
</template>
<script>
//import '@/assets/gtm.js'
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import FooterSeo from "@/components/footer-seo.vue";
//import ProductSwiper from "@/components/product-swiper.vue";
//import InstagramSwiper from "@/components/instagram-swiper.vue";
//import Quickview from "@/components/quickview.vue";
//import storeinfocus_swiper from "@/components/storeinfocus_swiper.vue";
//import brandsinfocus_swiper from "@/components/brandsinfocus-swiper.vue";
//import kiwikkrrush_swiper from "@/components/kiwikkrrush-swiper.vue";
//import specialselection_swiper from "@/components/specialselection_swiper.vue";
import Autocomplete from "@/components/auto-complete.vue";
//import Diwalipopup from "@/components/diwali-popup.vue";
//import Banner from "@/components/home/Banner.vue";
import CircleSlider from "@/components/CircleSlider.vue";
import Deals from "@/components/Deals.vue";
//import Offers from "@/components/Offers.vue";
import Offersbycategory from "@/components/Offers-by-category.vue";
import TopBrands from "@/components/TopBrands.vue";
import Clients from "@/components/home/Clients.vue";
export default {
	name: 'Dashboard',
	props: { 
		metadata: { type: Object },
	},
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		"footer-seo": FooterSeo,
		//"product-swiper": ProductSwiper,
		//"quickview": Quickview,
		//"instagram-swiper": InstagramSwiper,
		//"storeinfocus-swiper": storeinfocus_swiper,
		//"brandsinfocus-swiper": brandsinfocus_swiper,
		//"kiwikkrrush-swiper": kiwikkrrush_swiper,
		//"specialselection-swiper": specialselection_swiper,
		"auto-complete": Autocomplete,
		//"diwali-popup": Diwalipopup,
		//Banner,
		CircleSlider,
		Deals,
		//Offers,
		"Offers-by-category": Offersbycategory,
		TopBrands,
		Clients,
	},
	mounted(){
		/* let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-J5D103H4N0');
      document.head.appendChild(recaptchaScript);
        //this.initload();
		
		let s1 = document.createElement('script');
        s1.setAttribute('src', 'https://www.alluraa.com/js/js_main.js');
        document.head.appendChild(s1);*/
		
        this.initload();
		//this.$root.$emit('bv::show::modal', 'diwalipopup');
		//console.log('ss'+this.title);
        
	},
	data() {
		return{
            modal_data: {
                price: 0,
                special_price: 0
			},
			query:'',
			loading:false,
			slide:0,
			related_products: [],
			url: this.$root.WEBURL+'dealsoftheday',
			
			instagramfeed: [],
			feedindex: 4,
			recordUrlInsta: this.$root.NEWAPIURL+'profileapi/loadinsta',
		};
	},
	methods: {
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.url, {
                accesskey: self.$session.get('access_key'),
                products: 1
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.related_products = response.data.result.related_products;
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			
			
			/* Instagram */
			/* const params = {
			'Access-Control-Allow-Origin':'http://localhost:8080',
			'allow_origins':'http://localhost:8080',
		   'Content-Type': 'application/json',
		   'Access-Control-Allow-Credentials':'true',
		   'Access-Control-Allow-Headers' : 'Origin, Content-Type, Accept',
		   'Access-Control-Allow-Methods': 'GET, DELETE, HEAD, OPTIONS',
			
		  } */
		  
		  /*var optionAxios = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
			const instagramRegExp = new RegExp(/<script type="text\/javascript">window\._sharedData = (.*);<\/script>/)
			
			  const fetchInstagramPhotos = async (accountUrl) => {
			 // accountUrl.set('header','Access-Control-Allow-Origin', 'https://www.alluraa.com');
    //accountUrl.header('Access-Control-Allow-Methods', 'GET,PUT,OPTIONS');
				const response = await self.axios.get(accountUrl,optionAxios)
				const json = JSON.parse(response.data.match(instagramRegExp)[1])
				const edges = json.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(0, 12)
				const photos = edges.map(({ node }) => {
				  return {
					url: `https://www.instagram.com/p/${node.shortcode}/`,
					thumbnailUrl: node.thumbnail_src,
					displayUrl: node.display_url,
					caption: node.edge_media_to_caption.edges[0].node.text
				  }
				})
				return photos
			  }

			  (async () => {
				try {
				  self.instagramfeed = await fetchInstagramPhotos('https://www.instagram.com/alluraaTech/');
				  
				  
				} catch (e) {
				  console.error('Fetching Instagram photos failed', e)
				}
			  })() */
			
			/* ====================== */
			
			/*InstaGram From DB*/
			/*self.axios.post(self.recordUrlInsta, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    var tmp = response.data.result;
					console.log('InstaImage'+tmp);
					self.instagramfeed = tmp;
					
                    //self.loading = false;
				}else {
					//self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			}); */
			/* -------------------- */
		},
		changeQuerysearch() {
		  window.location = '/search/?q=' + this.query;
		  //this.name = submitEvent.target.elements.name.value
		}
	},
	 metaInfo() {
        //console.log('-------META INFO-------');
		 var ogImage = this.$root.MEDIAPATH+'images/og_mage.png';
		return{
			title: this.metadata.title,
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				/*{ name: 'keywords', content: this.metadata.keywords },*/
				{ name: 'keywords', content: this.metadata.keywords },
				{ name: 'description', content: this.metadata.description },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ property:'og:image', content: 'https://www.alluraa.com/media/images/logo.png' },
				
				{ name:'og:title', content: this.metadata.title },
				{ name:'og:description', content: this.metadata.description },
				{ name:'og:url', content: 'https://www.alluraa.com/' },
				{ name:'og:image', content: ogImage },
				
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' },
				{ name:'google-site-verification', content: 'vmDongoq7lJ25TIKoOEa2I6uG2VHRUFpXB4swZsO5xQ'},
				{ name:'p:domain_verify', content: '2414d644d27428df1547004055b7bcb0' }
				
				
			
				
				
			]
		}
	}
}
</script>
